import { breakpoints, pxToRem, themeGet, themeGetColor } from '@pocketlaw/tetris';
import styled from 'styled-components';
import { ICON_CONTAINER_WIDTH, SIDEBAR_PADDING, TRANSITION_SETTINGS } from '../config';
const SIDEBAR_MENU_WIDTH = pxToRem(260);
const SIDEBAR_MENU_WIDTH_MINIMIZED = `calc(${ICON_CONTAINER_WIDTH} + ${SIDEBAR_PADDING} * 2)`;
export const SidebarMenuContainer = styled.div `
  width: ${SIDEBAR_MENU_WIDTH};
  min-width: ${SIDEBAR_MENU_WIDTH_MINIMIZED};
  flex-shrink: 0;
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${themeGetColor('background.50')};
  border-right: ${pxToRem(1)} solid ${themeGetColor('border.100')};
  box-shadow: ${themeGet('dropShadow.400')};
  transition: width ${TRANSITION_SETTINGS};

  ${({ $minimized }) => $minimized &&
    `
    width: ${SIDEBAR_MENU_WIDTH_MINIMIZED};
  `};

  ${breakpoints.desktop} {
    background-color: transparent;
    border-right: none;
    box-shadow: none;
  }
`;
